var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonationPound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C3.1339 14 0 10.8661 0 7C0 3.1339 3.1339 0 7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14ZM4.9 7.7V9.1H4.2V10.5H9.8V9.1H6.3V7.7H8.4V6.3H6.3V5.6C6.29983 5.37328 6.37305 5.15259 6.50872 4.97093C6.64438 4.78928 6.8352 4.65641 7.05264 4.5922C7.27008 4.52799 7.50246 4.53589 7.71504 4.61471C7.92763 4.69354 8.10898 4.83905 8.232 5.0295L9.6222 4.6816C9.4088 4.15465 9.01883 3.71829 8.51908 3.44725C8.01934 3.1762 7.4409 3.08734 6.88284 3.19587C6.32478 3.30441 5.82181 3.60359 5.46008 4.04218C5.09834 4.48077 4.90035 5.03148 4.9 5.6V6.3H4.2V7.7H4.9Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationPound);
export default __webpack_public_path__ + "static/media/donationPound.fe02659f1c9ef587847e0c77366ca920.svg";
export { ForwardRef as ReactComponent };